import { motion } from "framer-motion";
import { AlertTriangle, Clock, PhoneOff, UserX, XCircle } from "lucide-react";

const problems = [
  { icon: Clock, text: "Leads not contacted fast enough" },
  { icon: PhoneOff, text: "No follow-up after inquiry" },
  { icon: UserX, text: "Low-quality leads wasting your time" },
  { icon: XCircle, text: "No booking or conversion system" },
];

const ProblemSection = () => {
  return (
    <section className="py-24 px-4 bg-background">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-destructive/10 text-destructive text-sm font-medium mb-6">
            <AlertTriangle className="h-4 w-4" />
            The Problem
          </div>
          <h2 className="text-display-md font-bold text-foreground mb-6">
            You're Losing Leads Right Now<br />(And Don't Even Know It)
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-4 mt-12 mb-12">
          {problems.map((problem, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="flex items-center gap-4 p-5 rounded-xl bg-card border border-border text-left"
            >
              <div className="p-2 rounded-lg bg-destructive/10">
                <problem.icon className="h-5 w-5 text-destructive" />
              </div>
              <span className="text-foreground font-medium">{problem.text}</span>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="p-6 rounded-2xl bg-destructive/5 border border-destructive/20"
        >
          <p className="text-lg font-semibold text-foreground">
            Most businesses lose <span className="text-destructive">30–50% of leads</span> after they come in.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ProblemSection;
